import { useState, useEffect, useRef } from 'react';

const getDateKey = (offset = 0) => {
  const d = new Date();
  d.setDate(d.getDate() + offset);
  return d.toISOString().slice(0, 10);
};

const STORAGE_KEY = 'dailyDictValues';

export function useDailyValues() {
  const [dailyValues, setDailyValues] = useState({});
  const todayKey = getDateKey();
  const yesterdayKey = getDateKey(-1);
  const lastDateRef = useRef(todayKey);

  // Load and initialize
  useEffect(() => {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};

    parsed[todayKey] = parsed[todayKey] || {};
    parsed[yesterdayKey] = parsed[yesterdayKey] || {};

    // Cleanup older dates
    Object.keys(parsed).forEach(k => {
      if (![todayKey, yesterdayKey].includes(k)) {
        delete parsed[k];
      }
    });

    localStorage.setItem(STORAGE_KEY, JSON.stringify(parsed));
    setDailyValues({ [yesterdayKey]: parsed[yesterdayKey], [todayKey]: parsed[todayKey] });
    lastDateRef.current = todayKey;
  }, []);

  const setValue = (key, value) => {
    const currentToday = getDateKey();
    const currentYesterday = getDateKey(-1);
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};

    // If day changed, rotate
    if (lastDateRef.current !== currentToday) {
      parsed[currentYesterday] = parsed[lastDateRef.current] || {};
      parsed[currentToday] = {};
      lastDateRef.current = currentToday;
    }

    // Update today's value
    parsed[currentToday] = { ...(parsed[currentToday] || {}), [key]: value };

    // Cleanup
    Object.keys(parsed).forEach(k => {
      if (![currentToday, currentYesterday].includes(k)) {
        delete parsed[k];
      }
    });

    localStorage.setItem(STORAGE_KEY, JSON.stringify(parsed));
    setDailyValues({ [currentYesterday]: parsed[currentYesterday], [currentToday]: parsed[currentToday] });
  };

  return [dailyValues, setValue, todayKey, yesterdayKey];
}